import styled, { css } from 'styled-components'

export const CheckboxDiv = styled.div<{ color: string }>`
  input[type='checkbox'] {
    -webkit-appearance: none;
    -moz-appearance: none;
    -ms-appearance: none;
    -o-appearance: none;
    appearance: none;
    position: relative;
    right: 0;
    bottom: 0;
    left: 0;
    height: 18px;
    width: 18px;
    vertical-align: -0.7rem;
    color: #fff;
    cursor: pointer;
    display: inline-block;
    margin: 0.4rem;
    outline: none;
    border-radius: 10%;
  }
  /* Checkbox */
  input[type='checkbox']:before,
  input[type='checkbox']:after {
    position: absolute;
    content: '';
    background: #fff;
  }
  input[type='checkbox']:before {
    left: 2px;
    top: 6px;
    width: 0;
    height: 2px;
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    -o-transform: rotate(45deg);
  }
  input[type='checkbox']:after {
    right: 9px;
    bottom: 3px;
    width: 2px;
    height: 0;
    transform: rotate(40deg);
    -webkit-transform: rotate(40deg);
    -moz-transform: rotate(40deg);
    -ms-transform: rotate(40deg);
    -o-transform: rotate(40deg);
  }
  input[type='checkbox']:checked:before {
    left: 0px;
    top: 9px;
    width: 6px;
    height: 2px;
  }
  input[type='checkbox']:checked:after {
    right: 4px;
    bottom: 0px;
    width: 2px;
    height: 14px;
  }
  input[type='checkbox']:indeterminate:before,
  input[type='checkbox']:indeterminate:after {
    width: 7px;
    height: 2px;
    transform: rotate(0);
    -webkit-transform: rotate(0);
    -moz-transform: rotate(0);
    -ms-transform: rotate(0);
    -o-transform: rotate(0);
  }
  input[type='checkbox']:indeterminate:before {
    left: 1px;
    top: 7px;
  }
  input[type='checkbox']:indeterminate:after {
    right: 1px;
    bottom: 7px;
  }
  input[type='checkbox'] {
    border: 2px solid #bebebe;
  }

  ${({ color }) => css`
    input[type='checkbox']:checked,
    input[type='checkbox']:indeterminate {
      border: 2px solid ${color};
      background: ${color};
    }
  `}
`
